import PropTypes from "prop-types";
import CommonFilterInput from "./CommonFilterInput";
import "./CommonFilters.css";

const CommonFilters = ({
  carriers,
  groups,
  assignees,

  programs,
  statuses = ["Complete", "Incomplete"],
  drugLists = [],

  carrierFilter = [],
  groupFilter = [],
  assigneeFilter = [],

  dispositionFilter = [],
  druglistFilter = [],
  programFilter = [],
  druglistSearch = "",

  onAssigneeChange,
  onCarrierChange,
  onGroupChange,
  onProgramChange,
  onDispositionChange,
  onDruglistChange,
  onSearch,

  onOpenDropdown,
  onLoadMoreOptions,
  loadingMap = {},
  hasMoreMap = {},
  autoPrefetch = true,
  compact = false,

  // Search value props
  programSearch = "",
  carrierSearch = "",
  groupSearch = "",
  assigneeSearch = "",
  visibleFilters = ["STATUS", "CARRIER", "GROUP", "PROGRAM", "ASSIGNEE"],
  showLabel = true,

  // Recent activity props
  recentActivityOutcomes = [],
  recentActivityNestedOptions = {},
  recentActivityOutcomeFilter = [],
  recentActivityReasonFilter = [],
  onRecentActivityChange,
}) => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const role = userDetails?.primaryRoleName;

  let assigneeOptions = Array.isArray(assignees) ? [...assignees] : [];
  if (!assigneeOptions.includes("Unassigned")) {
    const allIdx = assigneeOptions.findIndex(
      (opt) => opt.toLowerCase() === "all",
    );
    if (allIdx === -1) {
      assigneeOptions.unshift("Unassigned");
    } else {
      assigneeOptions.splice(allIdx + 1, 0, "Unassigned");
    }
  }

  return (
    <div className="common-filters">
      {visibleFilters.includes("STATUS") && (
        <CommonFilterInput
          label="Status"
          placeholder={compact ? "Status" : "Filter by Status"}
          value={dispositionFilter}
          onChange={onDispositionChange}
          options={statuses}
          type="select"
          multiple={true}
          onSearch={onSearch}
          filterType="STATUS"
          onOpen={onOpenDropdown}
          onLoadMore={onLoadMoreOptions}
          isLoading={loadingMap.STATUS}
          hasMore={hasMoreMap.STATUS}
          autoPrefetch={autoPrefetch}
          compact={compact}
          showLabel={showLabel}
        />
      )}

      {visibleFilters.includes("CARRIER") && role !== "L8" && (
        <CommonFilterInput
          label="Carrier"
          placeholder={compact ? "Carrier" : "Filter by Carrier"}
          value={carrierFilter}
          onChange={onCarrierChange}
          options={Array.isArray(carriers) ? carriers : []}
          type="select"
          multiple={true}
          onSearch={onSearch}
          filterType="CARRIER"
          onOpen={onOpenDropdown}
          isLoading={loadingMap.CARRIER}
          autoPrefetch={autoPrefetch}
          compact={compact}
          searchValue={carrierSearch}
          showLabel={showLabel}
        />
      )}
      {visibleFilters.includes("GROUP") && role !== "L8" && (
        <CommonFilterInput
          label="Group"
          placeholder={compact ? "Group" : "Filter by Group"}
          value={groupFilter}
          onChange={onGroupChange}
          options={Array.isArray(groups) ? groups : []}
          type="select"
          multiple={true}
          onSearch={onSearch}
          filterType="GROUP"
          onOpen={onOpenDropdown}
          isLoading={loadingMap.GROUP}
          autoPrefetch={autoPrefetch}
          compact={compact}
          searchValue={groupSearch}
          showLabel={showLabel}
        />
      )}

      {visibleFilters.includes("PROGRAM") && (
        <CommonFilterInput
          label="Program"
          placeholder={compact ? "Program" : "Filter by Programs"}
          value={programFilter}
          onChange={onProgramChange}
          options={Array.isArray(programs) ? programs : []}
          type="select"
          multiple={true}
          onSearch={onSearch}
          filterType="PROGRAM"
          onOpen={onOpenDropdown}
          onLoadMore={onLoadMoreOptions}
          isLoading={loadingMap.PROGRAM}
          hasMore={hasMoreMap.PROGRAM}
          autoPrefetch={autoPrefetch}
          compact={compact}
          searchValue={programSearch}
          showLabel={showLabel}
        />
      )}
      {visibleFilters.includes("DRUG_LIST") && (
        <CommonFilterInput
          label="Drug List"
          placeholder={compact ? "Drug List" : "Filter by Drug List"}
          value={druglistFilter}
          onChange={onDruglistChange}
          options={drugLists}
          type="select"
          multiple={true}
          onSearch={onSearch}
          filterType="DRUG_LIST"
          onOpen={onOpenDropdown}
          onLoadMore={onLoadMoreOptions}
          isLoading={loadingMap.DRUG_LIST}
          hasMore={hasMoreMap.DRUG_LIST}
          autoPrefetch={autoPrefetch}
          compact={compact}
          showLabel={showLabel}
          searchValue={druglistSearch}
        />
      )}
      {visibleFilters.includes("ASSIGNEE") && (
        <CommonFilterInput
          label="Assignee"
          placeholder={compact ? "Assignee" : "Filter by Assignee"}
          value={assigneeFilter}
          onChange={onAssigneeChange}
          options={assigneeOptions}
          type="select"
          multiple={true}
          onSearch={onSearch}
          filterType="ASSIGNEE"
          onOpen={onOpenDropdown}
          isLoading={loadingMap.ASSIGNEE}
          autoPrefetch={autoPrefetch}
          compact={compact}
          searchValue={assigneeSearch}
          showLabel={showLabel}
        />
      )}

      {visibleFilters.includes("RECENT_ACTIVITY") && (
        <CommonFilterInput
          label="Recent Activity"
          placeholder={
            compact ? "Recent Activity" : "Filter by Recent Activity"
          }
          value={recentActivityOutcomeFilter}
          onChange={onRecentActivityChange}
          options={recentActivityOutcomes}
          type="select"
          multiple={true}
          onSearch={onSearch}
          filterType="RECENT_ACTIVITY"
          onOpen={onOpenDropdown}
          isLoading={loadingMap.RECENT_ACTIVITY}
          autoPrefetch={autoPrefetch}
          compact={compact}
          showLabel={showLabel}
          nestedOptions={recentActivityNestedOptions}
          nestedValues={recentActivityReasonFilter}
          onNestedToggle={(parent, child) => {
            const parentReasons = Array.isArray(
              recentActivityNestedOptions?.[parent],
            )
              ? recentActivityNestedOptions[parent]
              : [];
            const nextReasons = recentActivityReasonFilter.includes(child)
              ? recentActivityReasonFilter.filter((r) => r !== child)
              : [...recentActivityReasonFilter, child];
            const hasAnyChildSelected = parentReasons.some((reason) =>
              nextReasons.includes(reason),
            );
            const nextOutcomes = hasAnyChildSelected
              ? Array.from(new Set([...recentActivityOutcomeFilter, parent]))
              : recentActivityOutcomeFilter.filter(
                  (outcome) => outcome !== parent,
                );
            onRecentActivityChange?.(nextOutcomes, nextReasons);
          }}
        />
      )}
    </div>
  );
};

export default CommonFilters;

CommonFilters.propTypes = {
  carriers: PropTypes.arrayOf(PropTypes.string),
  groups: PropTypes.arrayOf(PropTypes.string),
  assignees: PropTypes.arrayOf(PropTypes.string),

  programs: PropTypes.arrayOf(PropTypes.string),
  statuses: PropTypes.arrayOf(PropTypes.string),
  drugLists: PropTypes.arrayOf(PropTypes.string),

  carrierFilter: PropTypes.arrayOf(PropTypes.string),
  groupFilter: PropTypes.arrayOf(PropTypes.string),
  assigneeFilter: PropTypes.arrayOf(PropTypes.string),
  dispositionFilter: PropTypes.arrayOf(PropTypes.string),
  druglistFilter: PropTypes.arrayOf(PropTypes.string),
  programFilter: PropTypes.arrayOf(PropTypes.string),

  onAssigneeChange: PropTypes.func,
  onCarrierChange: PropTypes.func,
  onGroupChange: PropTypes.func,
  onProgramChange: PropTypes.func,
  onDispositionChange: PropTypes.func,
  onDruglistChange: PropTypes.func,
  onSearch: PropTypes.func,

  onOpenDropdown: PropTypes.func,
  onLoadMoreOptions: PropTypes.func,
  loadingMap: PropTypes.object,
  hasMoreMap: PropTypes.object,
  autoPrefetch: PropTypes.bool,
  compact: PropTypes.bool,
  programSearch: PropTypes.string,
  carrierSearch: PropTypes.string,
  groupSearch: PropTypes.string,
  druglistSearch: PropTypes.string,
  assigneeSearch: PropTypes.string,
  visibleFilters: PropTypes.arrayOf(PropTypes.string),
  showLabel: PropTypes.bool,
  recentActivityOutcomes: PropTypes.arrayOf(PropTypes.string),
  recentActivityNestedOptions: PropTypes.object,
  recentActivityOutcomeFilter: PropTypes.arrayOf(PropTypes.string),
  recentActivityReasonFilter: PropTypes.arrayOf(PropTypes.string),
  onRecentActivityChange: PropTypes.func,
};
